"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RightsholderContactListContentHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null,
        "Per regulatory requirements, song owners must make some contact information available in the Public Work Search. To protect your privacy, The MLC has added three different \u201Ccontact types\u201D that allow you to designate specific contact information for different uses.",
        ' ',
        react_1.default.createElement("strong", null, " Please note that only first name and email are required.")),
    react_1.default.createElement("p", null,
        "For full information about public database contact types, click\u00A0",
        react_1.default.createElement("a", { href: 'https://help.themlc.com/en/support/contact-types' }, "here."))));
exports.default = RightsholderContactListContentHeader;
